export default __webpack_public_path__ + "static/media/zoomin_PC.feeb700b.svg";